

import {UserActivityPage} from "./user-activity-page";

/**
 * An array of data with an associated page object used for paging
 */
export class UserActivityPageData<T> {
    data = new Array<T>();
    page = new UserActivityPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-activity-logs/user-activity-datatable/user-activity-page-data.ts